import { render, staticRenderFns } from "./MaskingModalGroupBadge.vue?vue&type=template&id=3a143f2f"
import script from "./MaskingModalGroupBadge.vue?vue&type=script&lang=ts"
export * from "./MaskingModalGroupBadge.vue?vue&type=script&lang=ts"
import style0 from "./MaskingModalGroupBadge.vue?vue&type=style&index=0&id=3a143f2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports